import React, { Component } from 'react';
import Select from 'react-select';
import map from 'lodash/map';
import i18n from '../../../../i18n/i18n.js';

type Props = {
    input: {
        onChange: Function,
        onBlur: Function,
        value: string,
        name: string,
    },
    type: string,
    options: {
        map: Function,
    },
    meta: {
        touched: boolean,
        error: string,
    },
    iconName: string,
    primaryColor: string,
    className: string,
    label: string,
    lng: string,
};

class SelectInput extends Component<Props> {
    constructor(props) {
        super(props);
        this.state = { activeField: false };
    }

    onChange(event) {
        if (this.props.input.onChange && event != null)
            // To be aligned with how redux-form publishes its CHANGE action payload.
            // The event received is an object with 2 keys: "value" and "label"
            this.props.input.onChange(event.value);
        // Clear the input field
        else this.props.input.onChange(null);
    }

    render() {
        let options;
        if (this.props.type === 'country') {
            options = this.props.options.map(country => {
                return { value: country.code, label: country.name };
            });
        } else {
            options = map(this.props.options, (value, key) => ({
                value: key,
                label: value,
            }));
        }

        const className =
            this.props.input.value !== '' &&
            this.props.input.value !== undefined
                ? 'active '
                : this.state.activeField
                    ? 'active '
                    : '';

        let isFieldInvalid =
            this.props.meta.touched &&
            this.props.meta.error &&
            !this.state.activeField;

        let validationClassName = isFieldInvalid ? 'invalid' : '';

        let iconClassName = '';
        if (this.props.iconName) {
            iconClassName = `ipic_${
                this.props.iconName
            } ${validationClassName}`;
        } else {
            iconClassName = `ipic_${
                this.props.input.name
            } ${validationClassName}`;
        }

        let iconColor = '#d7dde5';
        if (
            this.props.input.value !== '' &&
            this.props.input.value !== undefined
        ) {
            iconColor = this.props.primaryColor
                ? this.props.primaryColor
                : '#00aae6';
        }

        let lng = this.props.lng;
        let message = '';
        if (this.props.meta.error === 'required')
            message = i18n.t('required_field', { lng });

        return (
            <div className={this.props.className}>
                <Select
                    {...this.props}
                    value={this.props.input.value || ''}
                    onBlur={() => {
                        this.setState({ activeField: false });
                        this.props.input.onBlur(this.props.input.value);
                    }}
                    onFocus={() => this.setState({ activeField: true })}
                    onChange={this.onChange.bind(this)}
                    options={options}
                    placeholder=""
                    className={validationClassName}
                />
                <i
                    className={'react-select-icon ' + iconClassName}
                    style={{ color: isFieldInvalid ? '' : iconColor }}
                />
                <span
                    ref={label => (this.selectLabel = label)}
                    className={'selectlabel ' + className + validationClassName}
                >
                    {this.props.label}
                </span>
                {this.props.meta.touched &&
                this.props.meta.error &&
                !this.state.activeField ? (
                    <p className="select-validation-error">{message}</p>
                ) : (
                    ''
                )}
            </div>
        );
    }
}

export default SelectInput;



// WEBPACK FOOTER //
// ./src/ui/components/Inputs/Dropdown/index.js